// Import dependencies
import { html } from 'lit';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __, _x } from '@wordpress/i18n';

export default {
	tiers: [
		{
			id: 'lite',
			name: escapeHTML( _x( 'Lite', 'Upgrade', 'uncanny-automator' ) )
		},
		{
			id: 'basic',
			name: html`<uo-pro-tag></uo-pro-tag> ${ escapeHTML( _x( 'Basic', 'Upgrade', 'uncanny-automator' ) ) }`
		},
		{
			id: 'plus',
			name: html`<uo-pro-tag></uo-pro-tag> ${ escapeHTML( _x( 'Plus', 'Upgrade', 'uncanny-automator' ) ) }`
		},
		{
			id: 'elite',
			name: html`<uo-pro-tag></uo-pro-tag> ${ escapeHTML( _x( 'Elite', 'Upgrade', 'uncanny-automator' ) ) }`
		}
	],
	items: [
		{
			name: escapeHTML( _x( 'Usage limits', 'Upgrade', 'uncanny-automator' ) ),
			icon: 'hand',
			items: [
				{
					id: 'usage-limits-number-of-sites',
					name: escapeHTML( _x( 'Number of sites', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'The number of included license activations.', 'Upgrade', 'uncanny-automator' ) ),
					tiers: {
						lite: {
							status: false,
							text: '1'
						},
						basic: {
							status: false,
							text: '1'
						},
						plus: {
							status: false,
							text: '10'
						},
						elite: {
							status: false,
							text: '50'
						}
					}
				},
				{
					id: 'usage-limits-number-of-recipes',
					name: escapeHTML( _x( 'Unlimited recipes', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Create as many automation workflows as you need.', 'Upgrade', 'uncanny-automator' ) ),
					tiers: {
						lite: {
							status: 'available'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'usage-limits-number-of-recipe-runs',
					name: escapeHTML( _x( 'Unlimited recipe runs', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Run your recipes 1 or 1,000,000 times; with Uncanny Automator there are no additional costs.', 'Upgrade', 'uncanny-automator' ) ),
					tiers: {
						lite: {
							status: 'available'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'usage-limits-number-of-recipe-logs',
					name: escapeHTML( _x( 'Unlimited detailed logging', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Track every trigger and action with comprehensive logs. Store logs for as long as you want.', 'Upgrade', 'uncanny-automator' ) ),
					tiers: {
						lite: {
							status: 'available'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'usage-limits-multisite-support',
					name: escapeHTML( _x( 'WordPress Multisite support', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Use Automator in a multisite environment or send data and automate workflows between completely separate WordPress sites.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/wordpress-multisite/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'unavailable'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				}
			]
		},
		{
			name: escapeHTML( _x( 'Core features', 'Upgrade', 'uncanny-automator' ) ),
			icon: 'star',
			items: [
				{
					id: 'core-features-filter',
					name: escapeHTML( _x( 'Conditional actions', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Apply logic to determine whether actions should run.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/action-filters-conditions/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'core-features-schedule-delay',
					name: escapeHTML( _x( 'Scheduled/delayed actions', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Set workflows to run after a delay or at a specific day and time.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/scheduled-actions/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'core-features-users-loops',
					name: escapeHTML( _x( 'Users loops', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Run actions on users in bulk (e.g., send an email to all users who purchased a product).', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/user-loops/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'core-features-posts-loops',
					name: escapeHTML( _x( 'Posts loops', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Run actions on posts in bulk (e.g., change all posts by one author to another author).', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/post-loops/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'core-features-token-loops',
					name: escapeHTML( _x( 'Token loops', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Run actions on multiple items in a token (e.g., import users, posts and more from CSV, JSON or XML).', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/token-loops/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'core-features-create-users',
					name: escapeHTML( _x( 'Create new WordPress users', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Automatically add new users to your WordPress site based on specific triggers or conditions.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/article-categories/registering-users/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'core-features-run-now',
					name: escapeHTML( _x( 'Run now (instant) recipes', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Run recipes with a click.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/run-now/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'core-features-schedule-recipes',
					name: escapeHTML( _x( 'Scheduled recipes', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Run automations at a specific date and time or at specific intervals.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/schedule/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'core-features-magic-button',
					name: escapeHTML( _x( 'Magic buttons and magic links', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Create links and buttons that perform actions on users when clicked (e.g. register the user for a webinar).', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/magic-button/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				}
			]
		},
		{
			name: escapeHTML( _x( 'Power features', 'Upgrade', 'uncanny-automator' ) ),
			icon: 'dumbbell',
			items: [
				{
					id: 'power-features-email-attachments',
					name: escapeHTML( _x( 'Email attachments', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Attach files directly to emails sent with Uncanny Automator.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/wp-automation-stripe-membermouse/#:~:text=for%20course%20enrollment.-,Attach%20files%20to%20emails,-Another%20important%20new',
					tiers: {
						lite: {
							status: 'available'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'power-features-custom-triggers-actions',
					name: escapeHTML( _x( 'Custom triggers and actions', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Create custom triggers and actions to integrate Automator with almost any WordPress plugin.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: '',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'power-features-import-files',
					name: escapeHTML( _x( 'Import CSV, XML, JSON', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Import data from external sources and use it to create users, posts, custom post types and more.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/automator-pro-6-0-csv-json-xml-custom-actions-more/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'power-features-data-formatter',
					name: escapeHTML( _x( 'Data Formatter/Generator', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Easily manipulate and generate data within your recipes.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/the-formatter-action/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'power-features-date-time',
					name: escapeHTML( _x( 'Date and Time tools', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Work with dates and times using easy-to-use tools.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: '',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'power-features-qr-codes',
					name: escapeHTML( _x( 'Generate QR Codes', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Create and send QR codes in your automations.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: '',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'power-features-run-code',
					name: escapeHTML( _x( 'Run PHP and JavaScript', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Execute custom code.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: '',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'power-features-database-query',
					name: escapeHTML( _x( 'Database query', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Run SQL queries to pull data directly from your WordPress database to use in recipes.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/new-integration-database-query/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'power-features-automatic-cleanup',
					name: escapeHTML( _x( 'Automatic data cleanup', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Automatically prune recipe logs older than a specified age.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/new-in-pro-log-options-woo-bookings-more/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'power-features-advanced-logging',
					name: escapeHTML( _x( 'Advanced log filters', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Filter your recipe logs by recipe, user, status and more.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/action-filters-conditions/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				}
			]
		},
		{
			name: escapeHTML( _x( 'Integrations', 'Upgrade', 'uncanny-automator' ) ),
			icon: 'grid-round-2-plus',
			items: [
				{
					id: 'integrations-more-recipe-items',
					name: escapeHTML( _x( 'Thousands of pro-only triggers, actions and tokens', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Triple the number of triggers and actions available in Uncanny Automator Lite.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/all-triggers-and-actions/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'integrations-app-credits',
					name: escapeHTML( _x( 'App credits', 'Upgrade', 'uncanny-automator' ) ),
					description: html`
						${ escapeHTML( _x( 'Get credits for apps like:', 'Upgrade', 'uncanny-automator' ) ) }

						<ul>
							${
								[
									[ 'FACEBOOK',        escapeHTML( __( 'Facebook Pages', 'uncanny-automator' ) ) ],
									[ 'INSTAGRAM',       escapeHTML( __( 'Instagram', 'uncanny-automator' ) ) ],
									[ 'TWITTER',         escapeHTML( __( 'X/Twitter', 'uncanny-automator' ) ) ],
									[ 'ZOOM',            escapeHTML( __( 'Zoom', 'uncanny-automator' ) ) ],
									[ 'GOOGLE_CALENDAR', escapeHTML( __( 'Google Calendar', 'uncanny-automator' ) ) ],
									[ 'GOOGLESHEET',     escapeHTML( __( 'Google Sheets', 'uncanny-automator' ) ) ],
									[ 'SLACK',           escapeHTML( __( 'Slack', 'uncanny-automator' ) ) ]
								].map( ( [ code, name ] ) => html`
									<li>
										<uo-icon integration=${ code }></uo-icon>
										${ name }
									</li>
								` )
							}
						</ul>

						${ escapeHTML( _x( '...and many more!', 'Upgrade', 'uncanny-automator' ) ) }
					`,
					learn_more: 'https://automatorplugin.com/knowledge-base/what-are-credits/',
					tiers: {
						lite: {
							status: 'limited',
							text: '250 credits'
						},
						basic: {
							status: 'available',
							text: 'Unlimited'
						},
						plus: {
							status: 'available',
							text: 'Unlimited'
						},
						elite: {
							status: 'available',
							text: 'Unlimited'
						}
					}
				}
			]
		},
		{
			name: escapeHTML( _x( 'Webhooks', 'Upgrade', 'uncanny-automator' ) ),
			icon: 'webhook',
			items: [
				{
					id: 'webhook-authentication',
					name: escapeHTML( _x( 'Authentication', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Securely authenticate your webhooks.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: '',
					tiers: {
						lite: {
							status: 'available'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'webhook-headers',
					name: escapeHTML( _x( 'Headers', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Add custom headers to your webhook requests.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: '',
					tiers: {
						lite: {
							status: 'available'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'webhook-encoding',
					name: escapeHTML( _x( 'Multiple encoding types', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Send data in various formats like JSON, XML, and more.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: '',
					tiers: {
						lite: {
							status: 'available'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'webhook-nested-data',
					name: escapeHTML( _x( 'Nested data', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Easily send complex, nested data structures.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: '',
					tiers: {
						lite: {
							status: 'available'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'webhook-send',
					name: escapeHTML( _x( 'Send webhooks', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Trigger actions in other apps by sending data from your site.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/send-data-to-a-webhook/',
					tiers: {
						lite: {
							status: 'available'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'webhook-receive',
					name: escapeHTML( _x( 'Receive webhooks', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Enable other apps to send data to your site, triggering recipes remotely.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/knowledge-base/webhook-triggers/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				}
			]
		},
		{
			name: escapeHTML( _x( 'Customer support', 'Upgrade', 'uncanny-automator' ) ),
			icon: 'heart',
			items: [
				{
					id: 'support-premium',
					name: escapeHTML( _x( 'Premium support', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Unmatched support to help you get your automations up and running smoothly.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: '',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'available'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				}
			]
		},
		{
			name: escapeHTML( _x( 'Addons', 'Upgrade', 'uncanny-automator' ) ),
			icon: 'plug',
			items: [
				{
					id: 'addon-custom-user-fields',
					name: escapeHTML( _x( 'Custom User Fields', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Add custom fields (e.g. "Job Title") to user profiles and integrate them into Automator recipes for personalized workflows.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/custom-user-fields-addon/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'unavailable'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'addon-restrict-content',
					name: escapeHTML( _x( 'Restrict Content', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Restrict access to posts, pages, blocks, and shortcodes by role, access level, and profile fields to create membership sites, paywalls, and more.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/restrict-content-addon/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'unavailable'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'addon-user-lists',
					name: escapeHTML( _x( 'User Lists', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Manage mailing lists effortlessly to set up email newsletters and targeted campaigns. Let users manage their subscriptions with ease.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/user-lists-addon/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'unavailable'
						},
						plus: {
							status: 'available'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'addon-dynamic-content',
					name: html`
						${ escapeHTML( _x( 'Dynamic Content', 'Upgrade', 'uncanny-automator' ) ) } 
						<uo-chip 
							color="success"
							size="xsmall"
							filled
						>
							${ escapeHTML( _x( 'Coming soon', 'Upgrade', 'uncanny-automator' ) ) }
						</uo-chip>
					`,
					description: escapeHTML( _x( 'Generate dynamic blocks and shortcodes controlled by recipes. Show a progress bar that updates with purchases or display AI responses after form submissions.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: '',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'unavailable'
						},
						plus: {
							status: 'unavailable'
						},
						elite: {
							status: 'available'
						}
					}
				},
				{
					id: 'addon-elite-integrations',
					name: escapeHTML( _x( 'Elite Integrations', 'Upgrade', 'uncanny-automator' ) ),
					description: escapeHTML( _x( 'Connect your WordPress site to advanced platforms like Salesforce, enabling seamless data synchronization and enhanced business processes.', 'Upgrade', 'uncanny-automator' ) ),
					learn_more: 'https://automatorplugin.com/elite-integrations-addon/',
					tiers: {
						lite: {
							status: 'unavailable'
						},
						basic: {
							status: 'unavailable'
						},
						plus: {
							status: 'unavailable'
						},
						elite: {
							status: 'available'
						}
					}
				}
			]
		}
	]
};
